import React, { memo, useEffect } from 'react';

import _get from 'lodash/get';

import { useDevice } from '@bonnet/next/device';

import { useFeatures } from '@atc/features';

import { Carousel, Image, Link, Text } from 'reaxl';
import { sendClick, sendImpressions } from 'reaxl-analytics';
import { ContentPreview } from 'reaxl-molecules';

import { hyundaiBuyOnlineArticleClick, hyundaiBuyOnlineArticlesImpression } from '@/analytics/hyundaiBuyOnlineArticleEvents';

function HyundaiBuyOnlineArticles() {
    const device = useDevice();
    const isXs = _get(device, 'is.xs', true);

    const {
        editorial_articles: [, { articles: hyundaiEditorialArticles = [] }],
    } = useFeatures(['editorial_articles']);

    useEffect(() => {
        if (hyundaiEditorialArticles.length > 0) {
            sendImpressions({ name: hyundaiBuyOnlineArticlesImpression });
        }
    }, [hyundaiEditorialArticles]);

    const hyundaiArticleClick = (event) => {
        const pixallData = {
            category: event.category,
            make: event.make,
            model: event.model,
        };
        sendClick(hyundaiBuyOnlineArticleClick, event, { pixallData });
    };

    return hyundaiEditorialArticles.length > 0 && (
        <div className="col-xs-12 padding-top-5 padding-bottom-6">
            <Carousel
                cellWidth={`${isXs ? 90 : 40}%`}
                initialIndex={0}
                fullHeight
                fullWidth={false}
                lazyLoad={false}
                options={{
                    pageDots: false,
                    groupCells: true,
                    freeScroll: true,
                    prevNextButtons: !isXs,
                    cellAlign: 'left',
                    contain: true,
                    percentPosition: false,
                    adaptiveHeight: false,
                }}
                fullWidthScroll
                visibilityThreshold={0.9}
                version="2"
            >
                {hyundaiEditorialArticles.map((review) => (
                    <Link
                        key={review.id}
                        href={review.link}
                        target="_blank"
                        className="link-unstyled"
                        undecorated
                        onClick={() => hyundaiArticleClick(review)}
                    >
                        <ContentPreview
                            key="inventory-payment-snapshot"
                            category={(
                                <Text
                                    weight="bold"
                                    size={100}
                                >
                                    {review.category}
                                </Text>
                            )}
                            image={(
                                <Image
                                    src={review.image}
                                    height={87}
                                />
                            )}
                            headline={(
                                <Text size={200}>{review.title}</Text>
                            )}
                            orientation="landscape"
                            className="margin-right-3"
                        />
                    </Link>
                ))}
            </Carousel>
        </div>
    );
}

export default memo(HyundaiBuyOnlineArticles);
